"use client";
import Image from "next/image";
import React from "react";
import { IShop } from "../../../Orchestrator/Types/Index";
import "./AvailableShops.css";

interface AvailableShopsProps {
  shop: IShop;
}

const AvailableShops: React.FC<AvailableShopsProps> = ({ shop }) => {
  return (
    <div className="shop-card">
      <Image
        src={shop?.logo?.url || "/placeholder.png"}
        alt={shop?.logo?.alternativeText || shop.name}
        width={94.611}
        height={95.794}
      />
    </div>
  );
};

export default AvailableShops;
